export const NAV_ITEMS = [
  { key: "home", label: "Home", icon: "home" },
  { key: "inventory", label: "Inventory", icon: "box" },
  { key: "categories", label: "Categories", icon: "tag" },
  { key: "invoice", label: "Invoices", icon: "file" },
  { key: "suppliers", label: "Suppliers", icon: "store" },
  { key: "customers", label: "Customers", icon: "users" },
  { key: "reports", label: "Reports", icon: "chart" },
  { key: "employees", label: "Employees", icon: "users" },
  { key: "settings", label: "Settings", icon: "settings" },
];

export const SCREEN_META = {
  home: { title: "Activity", helper: "Stay on top of inventory, invoices, and suppliers in one place." },
  inventory: { title: "Inventory", helper: "Live stock levels, pricing, and upcoming expirations." },
  categories: { title: "Categories", helper: "Manage reusable groupings for your inventory catalog." },
  invoice: { title: "Invoices", helper: "Track invoices and settlement status across customers." },
  suppliers: { title: "Suppliers", helper: "Maintain supplier health, contacts, and product counts." },
  customers: { title: "Customers", helper: "Manage customer contacts, addresses, and preferences." },
  reports: { title: "Reports", helper: "Digest key metrics and performance snapshots." },
  employees: { title: "Employees", helper: "Invite teammates and manage their access." },
  settings: { title: "Settings", helper: "Update organization preferences and controls." },
};

export const SCREEN_CONFIG = {
  inventory: {
    columns: [
      { key: "image", label: "Image", width: "72px", sortable: false },
      { key: "name", label: "Name", width: "minmax(240px, 2.5fr)" },
      { key: "refCode", label: "Ref Code", width: "minmax(140px, 1.2fr)" },
      { key: "quantity", label: "Quantity", align: "right", width: "minmax(110px, 1fr)" },
      { key: "price", label: "Price", align: "right", width: "minmax(110px, 1fr)" },
      { key: "status", label: "Status", width: "minmax(130px, 1fr)" },
      { key: "expiry", label: "Expiry", width: "minmax(150px, 1fr)" },
    ],
    filters: ["All", "Available", "Low", "Out of stock", "Expiring soon", "Expired"],
    actionLabel: "+ New product",
  },
  categories: {
    actionLabel: null,
  },
  invoice: {
    columns: [
      { key: "item", label: "Client Name / Invoice No." },
      { key: "date", label: "Created", align: "right" },
      { key: "dueDate", label: "Due date", align: "right" },
      { key: "items", label: "Items", align: "right" },
      { key: "total", label: "Total", align: "right" },
      { key: "status", label: "Status" },
    ],
    filters: ["All", "Draft", "Unpaid", "Partial", "Paid", "Overdue", "Cancelled", "Void"],
    actionLabel: "+ Generate invoice",
  },
  suppliers: {
    columns: [
      { key: "item", label: "Supplier Name - Area" },
      { key: "phone", label: "Phone", align: "right" },
      { key: "products", label: "Products", align: "right" },
    ],
    filters: [],
    actionLabel: "+ New Supplier",
  },
  customers: {
    columns: [
      { key: "item", label: "Customer / Account" },
      { key: "phone", label: "Phone", align: "right" },
      { key: "email", label: "Email" },
    ],
    filters: [],
    actionLabel: "+ New Customer",
  },
  reports: {
    columns: [
      { key: "item", label: "Report / ID" },
      { key: "role", label: "Role", align: "right" },
      { key: "status", label: "Status" },
      { key: "action", label: "Action", align: "right" },
    ],
    filters: ["Lifetime", "This month", "Last month", "Last 90 days", "Custom"],
    actionLabel: "+ New Report",
  },
  settings: {
    actionLabel: "+ New user",
  },
  employees: {
    actionLabel: "+ New user",
  },
};
